import React, { useState } from 'react'
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import { FileUpload } from 'primereact/fileupload'
import './ImageModal.scss'
import AvatarEditor from 'react-avatar-editor'
import EmployeeService from '../../../service/EmployeeService'
import { ProgressSpinner } from 'primereact/progressspinner'
import http from '../../../core/http-common'
import loaderLogo from '../../../assets/icons/loading-filter.png'
import { useTranslation } from 'react-i18next'

const ImageModal = (props: { close: any; visible: any; getPicture: any; defaultPhoto: string }) => {
  const [scale, setScale] = useState<number>(1)
  const [rotation, setRotation] = useState<number>(0)
  const [base64URL, setBase64] = useState(props.getPicture())
  const [editor, setEditor] = useState<any>()
  const [isLoaderVisible, setLoaderVisible] = useState<boolean>(false)

  const { t } = useTranslation()

  const renderFooter = () => {
    return (
      <div className="btn-container">
        <div className="buttons">
          <Button
            label={t('buttons.cancel')}
            className="p-button-outlined  footer-button"
            style={{ border: '1px solid  #45bfe5', color: '#45bfe5' }}
            onClick={props.close}
          />
        </div>
        <div className="buttons">
          <Button
            label={t('buttons.save')}
            className="p-button-primary footer-button"
            disabled={base64URL.length > 0 && props.defaultPhoto !== base64URL ? false : true}
            onClick={() => savePhoto()}
          />
        </div>
      </div>
    )
  }
  const increaseScale = () => {
    setScale(scale + 1)
  }
  const decreaseScale = () => {
    if (scale !== 1) {
      setScale(scale - 1)
    }
  }
  const increaseRotate = () => {
    setRotation(rotation + 90)
  }
  const decreaseRotate = () => {
    setRotation(rotation - 90)
  }
  const onUpload = (event: any) => {
    convertBase64(event.files[0]).then((res: any) => {
      let base64string = res.split(',').pop()
      setBase64(base64string)
    })
  }

  const getEmployeePhoto = (url: string) => {
    return http.get<string>(url)
  }
  const convertBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(file)
      fileReader.onload = () => {
        resolve(fileReader.result)
      }
      fileReader.onerror = (error) => {
        reject(error)
      }
    })
  }
  const dataUrlToFile = (dataUrl: string, filename: string): File | undefined => {
    const arr = dataUrl.split(',')
    if (arr.length < 2) {
      return undefined
    }
    const mimeArr = arr[0].match(/:(.*?);/)
    if (!mimeArr || mimeArr.length < 2) {
      return undefined
    }
    const mime = mimeArr[1]
    const buff = Buffer.from(arr[1], 'base64')
    return new File([buff], filename, { type: mime })
  }

  const savePhoto = () => {
    if (editor) {
      const canvasScaled = editor.getImageScaledToCanvas()
      const canvas = canvasScaled.toDataURL()
      let id = 0
      const fileURL = dataUrlToFile(canvas, 'Test.png')
      const employee = JSON.parse(localStorage.getItem('employee') || '{}')
      id = employee.id || 0
      setLoaderVisible(true)
      EmployeeService.uploadEmployeeProfilePhoto(fileURL).then((resp) => {
        let photoUrl = EmployeeService.getEmployeePhotoBase64ById(id)
        getEmployeePhoto(photoUrl).then((response) => {
          localStorage.setItem('employeePhoto', response.data)
          localStorage.setItem('kvkkDisplay', 'false')
          setLoaderVisible(false)
          props.close()
        })
      })
    }
  }
  const deletePhoto = () => {
    EmployeeService.deleteEmployeeProfilePhoto().then((response) => {
      localStorage.setItem('employeePhoto', '')
      setBase64('')
    })
  }
  const setEditorRef = (editor: any) => {
    if (editor) {
      setEditor(editor)
    }
  }
  const loader = (src: any) => {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: '100px',
          width: '100%',
        }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            height: '100%',
            position: 'relative',
          }}>
          <ProgressSpinner style={{ width: '120px' }} />
          <img style={{ position: 'absolute', width: '35px' }} src={src} />
        </div>
      </div>
    )
  }
  const chooseOptions = {
    icon: 'none',
    iconOnly: false,
    className: 'p-button-text p-button-secondary',
    style: { textDecoration: 'underline', border: 'none', fontWeight: '1px' },
  }
  return (
    <>
      <Dialog
        header={t('profile.photo.change-profile-photo')}
        visible={props.visible}
        onHide={props.close}
        style={{ width: '400px', height: '530px' }}
        footer={renderFooter()}>
        {base64URL.length > 0 && props.defaultPhoto !== base64URL && (
          <div className="photo-options">
            <FileUpload
              accept="image/png,image/jpeg,image/jpg"
              maxFileSize={1000000}
              className="btn-photochange"
              mode="basic"
              url=""
              chooseLabel={t('profile.photo.change-the-photo')}
              chooseOptions={chooseOptions}
              onSelect={onUpload}
            />
            <Button
              className="p-button-rounded p-button-text btn-photodelete"
              onClick={() => deletePhoto()}
              icon="pi pi-trash"
            />
          </div>
        )}

        {!isLoaderVisible && (
          <div className="image-box">
            {base64URL.length > 0 && props.defaultPhoto !== base64URL ? (
              <>
                <div className="image-buttons">
                  <Button
                    icon="pi pi-plus"
                    className="p-button-secondary avatar-buttons"
                    onClick={() => {
                      increaseScale()
                    }}
                  />
                  <Button
                    icon="pi pi-minus"
                    className="p-button-secondary avatar-buttons"
                    onClick={() => {
                      decreaseScale()
                    }}
                  />
                  <Button
                    icon="pi pi-undo"
                    className="p-button-secondary avatar-buttons"
                    onClick={() => {
                      decreaseRotate()
                    }}
                  />
                  <Button
                    icon="pi pi-refresh"
                    className="p-button-secondary avatar-buttons"
                    onClick={() => {
                      increaseRotate()
                    }}
                  />
                </div>
                <AvatarEditor
                  image={'data:image/png;base64,' + base64URL}
                  ref={setEditorRef}
                  width={290}
                  height={270}
                  scale={scale}
                  style={{ borderRadius: '10px' }}
                  rotate={rotation}
                />
              </>
            ) : (
              <div className="new-image-container">
                <FileUpload
                  accept="image/png,image/jpeg,image/jpg"
                  mode="basic"
                  url=""
                  maxFileSize={1000000}
                  chooseLabel={t('profile.photo.upload-image')}
                  chooseOptions={{
                    icon: 'pi pi-upload',
                    style: {
                      height: '9rem',
                      with: '3rem',
                      borderRadius: '100%',
                      backgroundColor: '#45bfe5',
                      border: 'none',
                    },
                  }}
                  contentStyle={{ display: 'inline-block' }}
                  onSelect={onUpload}
                />
              </div>
            )}
          </div>
        )}
        {isLoaderVisible && loader(loaderLogo)}
      </Dialog>
    </>
  )
}

export default ImageModal
